'use client'

/**
 * Purpose: Survey pigmented axis page — slider when self-knowledge is yes, else questionnaire.
 * Inputs: formState, updateSection, setSlider, and tPages translator.
 * Outputs: SkinAxisSlider or SectionPage with PIGMENTED_QUESTIONS.
 */

import type { FormState } from '@lib/models/types'
import { PIGMENTED_QUESTIONS } from '@lib/survey-questions'
import { SectionPage } from '@components/pages/SectionPage/SectionPage'
import { SkinAxisSlider } from '@components/sliders/SkinAxisSlider/SkinAxisSlider'

export function SurveyPigmentedPage({
  formState,
  updateSection,
  setSlider,
  tPages,
}: {
  formState: FormState
  updateSection: (
    section: 'pigmentedAnswers',
    key: string,
    value: string,
  ) => void
  setSlider: (axis: 'pigmented', value: number) => void
  // updateSection writes one questionnaire answer key at a time.
  tPages: (key: string) => string
}) {
  // "I know my skin" → single slider; otherwise full question set.
  if (formState.skinKnowledge.pigmented) {
    return (
      <div id="survey-pigmented-page">
        {/* Self-reported axis value — skips the multi-question branch. */}
        <SkinAxisSlider
          value={formState.sliderValues.pigmented}
          onChange={(v) => setSlider('pigmented', v)}
          title={tPages('pigmentedSlider.title')}
          description={tPages('pigmentedSlider.description')}
          leftLabel={tPages('pigmentedSlider.leftLabel')}
          rightLabel={tPages('pigmentedSlider.rightLabel')}
        />
      </div>
    )
  }

  // Detailed questionnaire when user does not self-report axis knowledge.
  return (
    <div id="survey-pigmented-page">
      <SectionPage
        sectionKey="pigmentedNonPigmented"
        questions={PIGMENTED_QUESTIONS}
        answers={formState.pigmentedAnswers}
        onAnswer={(k, v) => updateSection('pigmentedAnswers', k, v)}
      />
    </div>
  )
}
